import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getArticle = async params => {
    const article = await axios.get('/service/article/', { params })
        .catch((e) => {
            throw new CustomException(e, 'Error fetching article data')
        })
    return article.data
}

export const getArticleErpAttributs = async articleCode => {
  const DIMENSIONS = [
    'longueur',
    'largeur',
    'hauteur',
    'densite',
    'diametre'
  ]
  const {
    longueur,
    largeur,
    hauteur,
    densite,
    poids,
    diametre,
    contenance,
    uniteDimensions,
    unitePoids
  } = await getArticle({ articleCode })
  const articleCache = {
    longueur,
    largeur,
    hauteur,
    densite,
    poids,
    diametre,
    contenance
  }
  return Object.entries(articleCache).reduce((acc, [attributProperty, attributValue]) => {
    if (attributValue === null) return acc
    let attribut = {
      propriete: attributProperty,
      nature: 'ERP'
    }
    if (attributProperty === 'poids') {
      attribut.suffixe = unitePoids
    } else {
      DIMENSIONS.forEach(dimension => {
        if (dimension === attributProperty)
          attribut.suffixe = uniteDimensions
      })
    }
    acc.push(attribut)
    return acc
  }, [])
}

export const getArticles = async params => {
  const articles = await axios.get('/service/articles', { params })
    .catch((e) => {
      throw new CustomException(e, 'Error fetching articles')
    })
  return articles.data
}

export const deleteArticle = async codeArticle => {
  const deleted = await axios.delete('/service/article', { params: { codeArticle: codeArticle } })
    .catch((e) => {
      throw new CustomException(e, 'Error fetching articles')
    })
  return deleted
}
